module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach1",
      "title": "Tip 1: Mastering Aperture Priority"
    }
  }, [_c('p', {
    staticClass: "chapno"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("TIP 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("Mastering Aperture Priority")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("Knowing how to control your aperture (f-stop) instead of just letting your camera do it for you on an automatic setting is one of the most important things you can do to better control the way your photos look. This is done primarily through a setting called Aperture Priority mode. A lens’s aperture is the opening in its center, usually created by a series of metal blades that overlap to create a circular shape when taking a photo. The smaller the opening, the higher the f-stop (commonly called the “f-number”). For example, f/16 and f/22 would be considered smaller apertures, and f/1.8 and f/2.8 would be considered larger apertures. Smaller apertures (higher f/stops) allow for more depth of field in your images compared with larger apertures (smaller f-stops).")]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_c('span', {
    staticClass: "gr"
  }, [_vm._v("APERTURE PRIORITY MODE AND DEPTH OF FIELD")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("There are two main reasons to use Aperture Priority mode. One is to control depth of field (the area that’s in acceptable focus, or sharp enough for your needs), and the other is to control how much light comes into the camera (both always happen together). On a given lens, lower f-stops like f/2.8 and f/4 let more light in than f/8 and f/16, as illustrated in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig1"
    }
  }, [_vm._v("fig. 1.1")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig2"
    }
  }, [_vm._v("fig. 1.2")]), _vm._v(". Much more light was needed (keeping all other things constant) for the f/16 exposure with which "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig2"
    }
  }, [_vm._v("fig. 1.2")]), _vm._v(" was shot than for the f/4.5 exposure with which "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig1"
    }
  }, [_vm._v("fig. 1.1")]), _vm._v(" was shot. About four times more light, or more accurately, four more exposure value (EV) levels were needed to expose both photos in a very similar way. EV represents a one-stop move, like f/2.8 to f/4. As the f-stop number increases by one full step, half the amount of light is allowed into the lens. For example, a setting of f/4 will allow half as much light in as f/2.8 (see the scale in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig3"
    }
  }, [_vm._v("fig. 1.3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Lenses with a wide maximum aperture (for example, 300mm f/2.8 lenses) are called fast lenses and tend to be larger and more expensive than slower lenses with similar magnification that might have a maximum aperture of about f/5.6. In many cases, zoom lenses, like an 18–135mm f/4–f/5.6 lens, have a relatively wide maximum aperture at wider focal lengths (in this example, f/4 at 18mm), but the maximum aperture changes automatically (in this example, f/5.6) as you reach the lens’s highest magnification level.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 1.1 Camera: Canon ...",
      "height": "225",
      "src": "images/f0011-01.jpg",
      "width": "340"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch1fig1"
    }
  }, [_c('b', [_vm._v("Fig. 1.1")]), _vm._v(" Camera: Canon EOS Rebel T4i; Lens: EF 70-300mm f/4-5.6 IS @ 95mm; F-stop: f/4.5; Exposure: 1/200 Sec.; ISO: 400")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 1.2 Camera: Canon ...",
      "height": "225",
      "src": "images/f0011-02.jpg",
      "width": "340"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch1fig2"
    }
  }, [_c('b', [_vm._v("Fig. 1.2")]), _vm._v(" Camera: Canon EOS Rebel T4i; Lens: EF 70-300mm f/4-5.6 IS @ 95mm; F-stop: f/16; Exposure: 1/15 Sec.; ISO: 400")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("I photographed the images in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig1"
    }
  }, [_vm._v("fig. 1.1")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig2"
    }
  }, [_vm._v("fig. 1.2")]), _vm._v(" just a few seconds apart using Aperture Priority mode. "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig1"
    }
  }, [_vm._v("Fig. 1.1")]), _vm._v(" was shot at f/4.5 and "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig2"
    }
  }, [_vm._v("fig. 1.2")]), _vm._v(" was shot at f/16. The look of both images is also very different due to the shallower depth of field in the f/4.5 image.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 1.3 Aperture scale.",
      "src": "images/f0012-01.jpg",
      "width": "600"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch1fig3"
    }
  }, [_c('b', [_vm._v("Fig. 1.3")]), _vm._v(" Aperture scale.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("SETTING YOUR APERTURE")]), _vm._v("—To allow in the greatest amount of light that your lens will allow, set Aperture Priority to the lowest f-stop possible (for example, f/2.8 or f/4), which will force your camera to use higher shutter speeds compared with when you set Aperture Priority to higher f-stops. The lower f-stops are especially useful when photographing sports, birds and wildlife, since the subjects tend to move a lot and they require faster shutter speeds (see "), _c('a', {
    attrs: {
      "href": "#/text/Chapter003"
    }
  }, [_vm._v("Tip 3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("DEPTH OF FIELD")]), _vm._v("—The real magic of photography happens when you take control of the depth of field in your images. If you look at most photos of major league baseball players (for example, batters or pitchers), you will usually see that the batter and pitcher are sharp, but the background behind them will be very out of focus. That is shallow depth of field at work. The photographer probably used lower f-stops like f/2.8 or f/4 combined with a long lens, like a 300 or even 600mm lens. This look can be truly fantastic, and the appearance of the out-of-focus areas that a lens produces is often called the lens’s “bokeh,” which comes from the Japanese term for blur. (An example of bokeh is seen in "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig4"
    }
  }, [_vm._v("Fig. 1.4")]), _vm._v(" where I used a lens that was made circa 1970 by using a special adapter—I love the bokeh the lens produces.)")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 1.4 Camera: Canon ...",
      "src": "images/f0012-02.jpg",
      "width": "355"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch1fig4"
    }
  }, [_c('b', [_vm._v("Fig. 1.4")]), _vm._v(" Camera: Canon EOS 6D; Lens: Asahi/Pentax 50mm f/1.4 Super Takumar @ 50mm; F-stop: f/1.4; Exposure: 1/800 Sec.; ISO: 1000")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The difference in the depth of field between "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig5"
    }
  }, [_vm._v("fig. 1.5")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#ch1fig6"
    }
  }, [_vm._v("fig. 1.6")]), _vm._v(" is very dramatic and is due to the difference in aperture, as well as the large distance between the flowers and the buildings. If the flowers were in a window very close to a building, there would not be as much of a visual difference (not as much background blur) using the same settings.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("To create photos with more depth of field (more sharpness across the image), use higher f-stops like f/8, f/16, etc. One good example of when to use higher f-stops to increase depth of field is when photographing groups of people standing or sitting in rows (like at a theater). More depth of field is also commonly desired when photographing landscapes.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 1.5 Camera: Canon ...",
      "src": "images/f0013-01.jpg",
      "width": "340"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch1fig5"
    }
  }, [_c('b', [_vm._v("Fig. 1.5")]), _vm._v(" Camera: Canon EOS D60; Lens: Canon Macro EF 50mm f/2.5; F-stop: f/2.8; Exposure: 1/4000 Sec.; ISO: 400")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Fig. 1.6 Camera: Canon ...",
      "src": "images/f0013-02.jpg",
      "width": "340"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "ch1fig6"
    }
  }, [_c('b', [_vm._v("Fig. 1.6")]), _vm._v(" Camera: Canon EOS D60; Lens: Canon Macro EF 50mm f/2.5; F-stop: f/13; Exposure: 1/350 Sec.; ISO: 400")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("These images were photographed just a few seconds apart using Aperture Priority mode. The left one was shot at f/2.8 and the right one at f/13. Shutter speeds were 1/4000 second and 1/350 second respectively.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("That being said, it’s important to note that as you reach your camera’s maximum f-stop, your images will generally get less sharp, even though the depth of field will be increasing. That f-stop is usually f/16, f/22 or f/32, depending on the removable lens or built-in lens (if you have a camera with a built-in lens). That’s due to something called diffraction, and to delve into some of the science behind it, I highly recommend an article on the topic over at "), _c('a', {
    attrs: {
      "href": "http://www.cambridgeincolour.com",
      "target": "_blank"
    }
  }, [_vm._v("www.cambridgeincolour.com")]), _vm._v(" (just search for the word “diffraction”).")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("To summarize this important topic, the range of items that will look in and out of focus from front to back is highly dependent on the f-stop you use, what lens you are using, how close you are to the subject(s), how much distance there is between the subjects from front to back and the size of your camera’s digital sensor. The best way to see this in action is to get out and make some photos for yourself, and the Pro Assignment that follows will help you to do just that.")]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("PRO ASSIGNMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "4",
      "src": "images/lineb.jpg",
      "width": "771"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subheading2"
  }, [_c('span', {
    staticClass: "bl"
  }, [_vm._v("Control Your Depth of Field with Aperture Priority Mode")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "bl"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Let’s start by assuming that you are taking photos outside, handheld (no monopod or tripod), with a medium-zoom lens (about 28–100mm) around midday in the spring or fall. Set your camera to Aperture Priority mode and your ISO to 200–800. This number will depend on your camera, lens and the type of photos you generally like to take. Late-model DSLRs and many mirrorless cameras can produce high-quality, virtually noise-free images at ISOs that would have produced very noisy images on similar cameras only a few years ago. Noise is often referred to as “digital grain,” and it looks like tiny white or colored specks in the image (especially in dark areas). Aim for lower ISOs when possible to minimize noise. Ambient temperature can also have an effect on noise in your images (lower temperatures will result in less noise, all other things being equal).")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "bl"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Find an interesting static object on which to focus that’s a few feet away, such as the bark of a tree, a car with an interesting background, etc. Start with the lowest f-stop that your lens allows (that’s its widest aperture) and take a series of horizontal photographs. Then slowly increase the f-stop until you reach f/22. Now switch to a vertical orientation and repeat the process.")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "bl"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Change to a longer lens (100–300mm) and repeat the process. This time, focus on an interesting object from the side, such as a lock on an old barn, an interesting piece of jewelry amongst many other pieces, etc.")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "bl"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Bring the photos into an image viewer or editor/converter like Adobe Bridge, IrfanView (free, Windows only), Apple iPhoto or Adobe Lightroom (my personal choice). Look carefully at the groups of images side by side that have different apertures to see how different they look. You can also see how you like the look of the out-of-focus areas, both in the foreground and background.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81305f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter001.vue
// module id = 78
// module chunks = 0